import Keycloak from 'keycloak-js';
import { environment } from '@environments/environment';
import { KeycloakManagerConfig } from '@shared/services/keycloak-manager/keycloak-manager.config';

export class KeycloakManager {
  private static instance: Keycloak | null = null;

  public static getInstance(): Keycloak {
    if (!this.instance) {
      this.instance = new Keycloak({
        url: environment.ssoUrl,
        realm: KeycloakManagerConfig.realm,
        clientId: KeycloakManagerConfig.clientId,
      });
    }
    return this.instance;
  }

  public static reset(): void {
    this.instance = null;
  }
}
